import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Col,
  Form,
  Row,
  Tab,
  Nav,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import { post, postFormData } from "../../../helpers/api_helper";

import { Spin } from "antd";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import { Fragment } from "react";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import {
  delete_Record,
  ActiveInactive_Record,
  warningMessage,
  successMessage,
  errorMessage,
  validateEmailField,
  validateMobileNoField,
  capitalizeString,
  customConfirmDialog,
} from "../CommonFunctions";
import {
  POST_CustomerContactPersonActiveInActive,
  POST_CustomerContactPersonDelete,
  POST_CustomerContactPersonDetailInsert,
  POST_CustomerContactPersonDetailUpdate,
  POST_CustomerGSTExemptionDocFileSave,
  POST_CustomerInsert,
  POST_CustomerLoginLinkSend,
  POST_CustomerProjectAddressActiveInActive,
  POST_CustomerProjectAddressDelete,
  POST_CustomerProjectAddressInsert,
  POST_CustomerProjectAddressUpdate,
  POST_CustomerProjectsActiveInActive,
  POST_CustomerProjectsInsert,
  POST_CustomerProjectsUpdate,
  POST_CustomerRestPassword,
  POST_CustomerUpdate,
  POST_GetAllCustomerRepresentativeDropDown,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetCustomerContactPersonDetailByID,
  POST_GetCustomerDetailByID,
  POST_GetCustomerProjectAddressDetailByID,
  POST_GetCustomerProjectDetailByID,
  POST_GetCustomerProjectList,
} from "../../../helpers/url_helper";
import QuickAddCategory from "../Categories/QuickAddCategory";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import swal from "sweetalert";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";

const AddCustomer = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { IsQuickAddCustomerParam, PrimaryIdParam } = useParams();

  const [tab, setTab] = useState(1);
  const [projectDetailModal, setProjectDetailModal] = useState(false);

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [customerRepresentativeOptions, setCustomerRepresentativeOptions] =
    useState([]);

  const [managementName, setManagementName] = useState("");
  const [addProjectNameModal, setAddProjectNameModal] = useState(false);
  const [addProjectDetailModal, setAddProjectDetailModal] = useState(false);
  const [addContactPersonsDetailModal, setAddContactPersonsDetailModal] =
    useState(false);

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");
  const [customerProjectListOptions, setCustomerProjectListOptions] = useState(
    [],
  );
  const [projectTypeShowFlag, setProjectTypeShowFlag] = useState(0);

  const [stampImage, setStampImage] = useState(null);
  const [stampImageFile, setStampImageFile] = useState(null);
  const [validationStampImage, setValidationStampImage] = useState("");

  const [customerProjectsList, setCustomerProjectsList] = useState([]);
  const [customerProjectAddressList, setCustomerProjectAddressList] = useState(
    [],
  );
  const [customerContactPersonsList, setCustomerContactPersonsList] = useState(
    [],
  );
  const [
    customerProjectContactPersonList,
    setCustomerProjectContactPersonList,
  ] = useState([]);
  const [customerProjectIDEncryptForList, setCustomerProjectIDEncryptForList] =
    useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  useEffect(() => {
    loadCustomerProjectDDL();
    getCountryDDL();
    getDesignationDDL();
    getCustomerRepresentativeDDL();

    if (PrimaryIdParam) {
      LoadData(window.atob(PrimaryIdParam));
    } else {
      setIsLoading(false);
    }
  }, []);

  // console.log("List", customerProjectAddressList);

  const fnCallback = () => {
    if (CustomerIDEncrypt) {
      LoadData(CustomerIDEncrypt);
    }
  };

  const LoadData = (CustomerIDEncrypt) => {
    if (CustomerIDEncrypt) {
      post(POST_GetCustomerDetailByID, {
        CustomerIDEncrypt: CustomerIDEncrypt,
        BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formik.setValues({
              ...response,
              CustomerIDEncrypt: response?.CustomerIDEncrypt,
              OpeningBalanceDate: response?.OpeningBalanceDate
                ? new Date(response.OpeningBalanceDate)
                : "",
              ExemptionFromDate: response?.ExemptionFromDate
                ? new Date(response.ExemptionFromDate)
                : "",
              ExemptionToDate: response?.ExemptionToDate
                ? new Date(response.ExemptionToDate)
                : "",
            });

            setCustomerProjectsList([...response?.ListOfCustomerProjects]);

            setCustomerProjectAddressList([
              ...response?.ListOfCustomerProjectAddress,
            ]);
            setCustomerContactPersonsList([
              ...response?.ListOfCustomerContactPersons,
            ]);
            // setCustomerProjectContactPersonList([
            //   ...response?.ListOfCustomerProjectContactPerson,
            // ]);
            setCustomerProjectContactPersonList([
              ...response?.ListOfContactPerson,
            ]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };

  const loadCustomerProjectDDL = () => {
    post(POST_GetCustomerProjectList, {
      CustomerIDEncrypt: CustomerIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((res) => {
        if (res.IsSuccess) {
          setCustomerProjectListOptions(
            res.CustomerProjectDDLList.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
              ManagementName: item.ManagementName,
            })),
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const getCustomerRepresentativeDDL = () => {
    setIsLoading(true);
    post(POST_GetAllCustomerRepresentativeDropDown, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerRepresentativeOptions(
            response?.ListOfCustomerRepresentative?.map((item) => ({
              label: item?.ProjectHandleByName,
              value: item?.ProjectHandleByEncrypted,
              IsDefault: item?.IsDefault,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCountryDDL = () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 1,
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCountryOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getStateDDL = (CountryID) => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 2,
      ParentCategoryID: CountryID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStateOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
          if (
            response?.List?.length > 0 &&
            StateID &&
            response?.List?.filter((x) => x.CategoryID == StateID).length == 0
          ) {
            formikCustomerProjectDetail.setFieldValue("StateID", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.List?.length == 1 &&
              !CustomerProjectAddressIDEncrypt
            ) {
              formikCustomerProjectDetail.setFieldValue(
                "StateID",
                response?.List[0].CategoryID,
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDesignationDDL = (CountryID) => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 5,
      ParentCategoryID: CountryID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDesignationOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCityDDL = (StateID) => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 3,
      ParentCategoryID: StateID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCityOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
          if (
            response?.List?.length > 0 &&
            CityID &&
            response?.List?.filter((x) => x.CategoryID == CityID).length == 0
          ) {
            formikCustomerProjectDetail.setFieldValue("CityID", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.List?.length == 1 &&
              !CustomerProjectAddressIDEncrypt
            ) {
              formikCustomerProjectDetail.setFieldValue(
                "CityID",
                response?.List[0].CategoryID,
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const gSTRegistrationTypeOptions = [
    { label: "Regular", value: 1 },
    { label: "Un-Registered", value: 2 },
  ];

  const gstSEZTypeOptions = [
    { label: "SEZ With Payment", value: 1 },
    { label: "SEZ Without Payment", value: 2 },
  ];

  const invoiceFormatTypeOptions = [
    { label: "Invoice Format - 1", value: 1 },
    { label: "Invoice Format - 2", value: 2 },
  ];

  const validationSchema = Yup.object().shape({
    CustomerName: Yup.string()
      .trim()
      .required("Customer Name is required field"),
    // ShortName: Yup.string().trim().required("Short Name is required field"),

    GSTNo: Yup.string().when(
      "GSTRegistrationType",
      ([GSTRegistrationType], schema) => {
        if (GSTRegistrationType == 1)
          return Yup.string().required("GST No is required field");
        return schema;
      },
    ),

    // GSTNo: Yup.string().required("GST No is required field"),
    // EmailID: Yup.string().trim().required("Email is required field"),
    GSTRegistrationType: Yup.string().required(
      "GST Registration Type is required field",
    ),
    IsDefaultCreditPeriodDaysValue: Yup.string().when(
      "IsDefaultCreditPeriodDays",
      ([IsDefaultCreditPeriodDays], schema) => {
        if (AuthUser?.Permissions?.Account === 1) {
          if (IsDefaultCreditPeriodDays == true)
            return Yup.string().required(
              "Credit Period Days is required field",
            );
          return schema;
        }
      },
    ),
    IsSecurityCreditLimitRsValue: Yup.string().when(
      "IsSecurityCreditLimitRs",
      ([IsSecurityCreditLimitRs], schema) => {
        if (AuthUser?.Permissions?.Account === 1) {
          if (IsSecurityCreditLimitRs == true)
            return Yup.string().required(
              "Credit Limit Amount is required field",
            );
          return schema;
        }
      },
    ),

    UserName: Yup.string().when("LoginFlag", ([LoginFlag], schema) => {
      if (LoginFlag == true)
        return Yup.string().required("User Name is required field");
      return schema;
    }),
    // Password: Yup.string().when("LoginFlag", ([LoginFlag], schema) => {
    //   if (LoginFlag == true)
    //     return Yup.string().required("User Name is required field");
    //   return schema;
    // }),

    EmailID: Yup.string().when("LoginFlag", ([LoginFlag], schema) => {
      if (LoginFlag == true)
        return Yup.string().required("Email ID is required field");
      return schema;
    }),

    GSTSEZType: Yup.number().when(
      "CustomerInSEZ",
      ([CustomerInSEZ], schema) => {
        if (CustomerInSEZ == true)
          return Yup.number()
            .required("GST SEZ Type is required field")
            .min(1, "GST SEZ Type is required field");
        return schema;
      },
    ),
    // ExemptionFromDate: Yup.string().when(
    //   "CustomerInSEZ",
    //   ([CustomerInSEZ], schema) => {
    //     if (CustomerInSEZ == true)
    //       return Yup.string().required("Exemption From Date is required field");
    //     return schema;
    //   }
    // ),
    // ExemptionToDate: Yup.string().when(
    //   "CustomerInSEZ",
    //   ([CustomerInSEZ], schema) => {
    //     if (CustomerInSEZ == true)
    //       return Yup.string().required("Exemptio To Date is required field");
    //     return schema;
    //   }
    // ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CustomerIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      CustomerName: "",
      ShortName: "",
      EmailID: "",
      GSTRegistrationType: "",
      GSTNo: "",
      PanNo: "",
      VendorCode: "",
      IsTPI: false,
      LoginFlag: false,
      LoginIDEncrypt: "",
      UserName: "",
      Password: "",
      OpeningBalance: "",
      OpeningBalanceDate: "",
      PerformaInvoiceRequired: false,
      IsDefaultCreditPeriodDays: false,
      IsSecurityCreditLimitRs: false,
      IsCashOnly: false,
      IsDefaultCreditPeriodDaysValue: "",
      IsSecurityCreditLimitRsValue: "",
      CustomerInSEZ: false,
      GSTSEZType: 0,
      ExemptionFromDate: "",
      ExemptionToDate: "",
      ExemptionDocFile: "",
      ExemptionDocFilePath: "",
      ExemptionDocFileKey: "",
      IsInward: false,
      IsInvoice: false,
      IsLedger: false,
      IsOutstanding: false,
      InvoiceFormatType: 1,
      CustomerRepresentativeIDEncrypt: "",
    },
    validateOnBlur: false,
  });

  const extractPANFromGST = (value) => {
    return value.substring(2, 13);
  };

  const formatGST = (value) => {
    // Remove non-alphanumeric characters
    const rawValue = value.replace(/[^a-zA-Z0-9]/g, "");

    // Format with spaces/dashes based on GST structure (State Code + PAN + Entity + Z + Checksum)
    const formattedValue = rawValue
      .replace(/^(.{2})(.{10})?/, "$1 $2") // State Code and PAN
      .replace(/^(.{2} .{10})(.{1})?/, "$1 $2") // PAN and Entity Code
      .replace(/^(.{2} .{10} .{1})(.{1})?/, "$1 $2") // Entity Code and Z
      .replace(/^(.{2} .{10} .{1} .{1})(.{1})?/, "$1 $2"); // Z and Checksum

    return formattedValue.trim();
  };

  const handleChangeGst = (e) => {
    const value = e.target.value.toUpperCase();

    // Ensure first two digits (State Code) are numeric
    const stateCode = value.substring(0, 2);
    if (stateCode && isNaN(stateCode)) {
      return; // Prevent update if first two characters aren't digits
    }
    const entityCode = value.substring(13, 14); // The 13th character is the Entity Code
    if (entityCode && isNaN(entityCode)) {
      return;
    }

    // Format the GST number
    const formattedValue = formatGST(value);
    formik.setFieldValue("GSTNo", formattedValue); // Update the GST No in Formik

    // Extract the PAN from the GST number and update the corresponding field in Formik
    const panFromGST = extractPANFromGST(value);
    formik.setFieldValue("PanNo", panFromGST); // Update the PanNo field dynamically
  };

  const {
    setFieldValue,
    values: {
      CustomerIDEncrypt,
      CustomerName,
      IsTPI,
      PerformaInvoiceRequired,
      IsDefaultCreditPeriodDays,
      IsSecurityCreditLimitRs,
      IsCashOnly,
      LoginFlag,
      LoginIDEncrypt,
      IsDefaultCreditPeriodDaysValue,
      IsSecurityCreditLimitRsValue,
      GSTRegistrationType,
      CustomerInSEZ,
      ExemptionFromDate,
      ExemptionToDate,
      ExemptionDocFile,
      ExemptionDocFilePath,
      ExemptionDocFileKey,
      UserName,
      IsInward,
      IsInvoice,
      IsLedger,
      IsOutstanding,
      EmailID,
      InvoiceFormatType,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (AuthUser?.Permissions?.Account === 1) {
      if (
        IsDefaultCreditPeriodDays === false &&
        IsSecurityCreditLimitRs === false &&
        IsCashOnly === false
      ) {
        // swal({
        //   title: "warning",
        //   text: "atleast one checkbox check (DefaultCreditPeriodDays/SecurityCreditLimitRs/CashOnly)",
        //   icon: "warning",
        //   button: "OK",
        // });
        warningMessage(
          // "atleast one checkbox check (DefaultCreditPeriodDays/SecurityCreditLimitRs/CashOnly)"
          "Please select one option from (Cash Only / Credit Period Days / Credit Limit Amount)",
        );
        // setIsLoading(false);
        return;
      }
    }

    let payload = {
      ...values,
      OpeningBalanceDate: values?.OpeningBalanceDate
        ? moment(values?.OpeningBalanceDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",
      IsDefaultCreditPeriodDays: values?.IsCashOnly
        ? false
        : values?.IsDefaultCreditPeriodDays,
      IsSecurityCreditLimitRs: values?.IsCashOnly
        ? false
        : values?.IsSecurityCreditLimitRs,
      IsDefaultCreditPeriodDaysValue: values?.IsCashOnly
        ? ""
        : values?.IsDefaultCreditPeriodDaysValue,
      IsSecurityCreditLimitRsValue: values?.IsCashOnly
        ? ""
        : values?.IsSecurityCreditLimitRsValue,
      OpeningBalance: values?.OpeningBalance ? values?.OpeningBalance : 0,
      CompanyName: AuthUser?.CompanyName,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      LoginIDEncrypt: values?.LoginIDEncrypt,
      GSTSEZType: values?.CustomerInSEZ == true ? values?.GSTSEZType : 0,
      ExemptionFromDate: "",
      ExemptionToDate: "",
      SendEmailPermissions: AuthUser?.Permissions?.Email,
      // ExemptionFromDate:
      //   values?.ExemptionFromDate && values?.CustomerInSEZ == true
      //     ? moment(values?.ExemptionFromDate)
      //         .format("YYYY-MM-DD")
      //         .replace(/^\-/, "")
      //     : "",
      // ExemptionToDate:
      //   values?.ExemptionToDate && values?.CustomerInSEZ == true
      //     ? moment(values?.ExemptionToDate)
      //         .format("YYYY-MM-DD")
      //         .replace(/^\-/, "")
      //     : "",
    };
    setIsLoading(true);

    post(CustomerIDEncrypt ? POST_CustomerUpdate : POST_CustomerInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          //successMessage(response?.Message);
          if (
            values?.ExemptionDocFile ||
            !values?.ExemptionDocFilePath ||
            (values?.CustomerInSEZ == false && values?.ExemptionDocFilePath)
          ) {
            saveExemptionDocFile(
              !values?.CustomerIDEncrypt
                ? response?.EncryptID
                : values?.CustomerIDEncrypt,
              values,
              response?.Message,
            );
          } else {
            successMessage(response?.Message);
          }

          if (PrimaryIdParam) {
            if (IsQuickAddCustomerParam == "true") {
              closeTab(1);
            } else {
              setTimeout(() => {
                navigate("/customer");
              }, 1000);
            }
          } else {
            setTimeout(() => {
              LoadData(response?.EncryptID);
              formik.setFieldValue("CustomerIDEncrypt", response?.EncryptID);
            }, 1000);

            if (CustomerIDEncrypt) {
              if (IsQuickAddCustomerParam == "true") {
                closeTab(1);
              } else {
                setTimeout(() => {
                  navigate("/customer");
                }, 1000);
              }
            }
          }
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    //setIsLoading(false);
  };

  useEffect(() => {
    if (LoginFlag) {
      if (EmailID) {
        formik.setFieldValue("UserName", EmailID);
      }
    } else {
      formik.setFieldValue("UserName", "");
    }
  }, [LoginFlag]);

  const addProjectDetail = () => {
    formikCustomerProjectDetail.resetForm();
    /*select the value when there is only one option while insert only*/
    if (customerProjectListOptions?.length == 1) {
      formikCustomerProjectDetail.setFieldValue(
        "CustomerProjectID",
        customerProjectListOptions[0]?.value,
      );
      formikCustomerProjectDetail.setFieldValue(
        "ProjectName",
        customerProjectListOptions[0]?.label,
      );
      formikCustomerProjectDetail.setFieldValue(
        "ManagementName",
        customerProjectListOptions[0]?.ManagementName,
      );
      setManagementName(customerProjectListOptions[0]?.ManagementName);
    }
    if (countryOptions?.length == 1) {
      formikCustomerProjectDetail.setFieldValue(
        "CountryID",
        countryOptions[0]?.value,
      );
    }
    setAddProjectDetailModal(true);
  };

  const editProjectAddress = (ID) => {
    if (ID) {
      post(POST_GetCustomerProjectAddressDetailByID, {
        CustomerProjectAddressIDEncrypt: ID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikCustomerProjectDetail.setValues({
              ...response,
              CustomerProjectID: response?.CustomerProjectIDEncrypt,
            });

            formikCustomerProjectDetail.setFieldValue(
              "ProjectName",
              response?.ProjectName,
            );

            formikCustomerProjectDetail.setFieldValue(
              "ManagementName",
              response?.ManagementName.trim(),
            );
            setManagementName(response?.ManagementName);
          }
          setIsLoading(false);
          setAddProjectDetailModal(true);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };

  const validationSchemaCustomerProjectDetail = Yup.object().shape({
    CustomerProjectID: Yup.string()
      .trim()
      .required("Customer Project is required field"),
    Address: Yup.string().trim().required("Address Line 1 is required field"),
    // CityID: Yup.string().trim().required("City is required field"),
    // StateID: Yup.string().trim().required("State is required field"),
    // CountryID: Yup.string().trim().required("Country is required field"),
  });

  const formikCustomerProjectDetail = useFormik({
    validationSchema: validationSchemaCustomerProjectDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCustomerProjectDetail(values, formikHelpers),
    initialValues: {
      CustomerIDEncrypt: "",
      CustomerProjectAddressIDEncrypt: "",
      CustomerProjectID: "",
      Address: "",
      CityID: "",
      StateID: "",
      CountryID: "",
      Pincode: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      IsBilling: false,
      IsReporting: false,
      IsDispatchReport: false,
      IsDispatchMaterial: false,
      ProjectName: "",
      ManagementName: "",
      CountryName: "",
      StateName: "",
      CityName: "",
      Address2: "",
      Address3: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      CountryCode,
      IsBilling,
      IsReporting,
      IsDispatchReport,
      IsDispatchMaterial,
      CityID,
      StateID,
      CountryID,
      CustomerProjectID,
      CustomerProjectAddressIDEncrypt,
    },
  } = formikCustomerProjectDetail;

  const handleValidSubmitCustomerProjectDetail = (values) => {
    if (
      IsBilling === false &&
      IsReporting === false &&
      IsDispatchReport === false &&
      IsDispatchMaterial === false
    ) {
      warningMessage(
        //"Please select one option from (Billing / Reporting / Dispatch Report / Dispatch Material)"
        `Please select one option from (Billing / Reporting ${
          AuthUser?.Permissions?.DispatchReport == 1 ? "/ Dispatch Report" : ""
        } ${
          AuthUser?.Permissions?.DispatchMaterial == 1
            ? "/ Dispatch Material"
            : ""
        })`,
      );
      //setIsLoading(false);
      return;
    }
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo,
      )
    ) {
      formikCustomerProjectDetail.setFieldError(
        "MobileNo",
        "Please enter a valid mobile number",
      );
      formikCustomerProjectDetail.setFieldTouched("MobileNo", true);
      return false;
    }

    let payload = {
      ...values,
      CityID: values.CityID ? values.CityID : 0,
      StateID: values.StateID ? values.StateID : 0,
      CountryID: values.CountryID ? values.CountryID : 0,
      CustomerIDEncrypt: CustomerIDEncrypt,
      CustomerProjectIDEncrypt: values.CustomerProjectID,
      CountryCode: "+" + CountryCode.replace(/\+/g, ""),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    // console.log("Add", payload);
    post(
      CustomerProjectAddressIDEncrypt
        ? POST_CustomerProjectAddressUpdate
        : POST_CustomerProjectAddressInsert,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            LoadData(CustomerIDEncrypt);
            formikCustomerProjectDetail.resetForm();
            setAddProjectDetailModal(false);
          }, 1000);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    // setIsLoading(false);
  };

  const addProjectName = (type) => {
    formikCustomerProjectNameAdd.resetForm();
    setAddProjectNameModal(true);
    setProjectTypeShowFlag(type);
  };

  const editProjectName = () => {
    if (CustomerProjectID) {
      post(POST_GetCustomerProjectDetailByID, {
        CustomerProjectIDEncrypt: CustomerProjectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikCustomerProjectNameAdd.setValues({
              ...response,
            });
            setAddProjectNameModal(true);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const validationSchemaCustomerProjectNameAdd = Yup.object().shape({
    ProjectName: Yup.string().trim().required("Project Name is required field"),
    // ManagementName: Yup.string()
    //   .trim()
    //   .required("Management Name is required field"),
  });

  const formikCustomerProjectNameAdd = useFormik({
    validationSchema: validationSchemaCustomerProjectNameAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCustomerProjectNameAdd(values, formikHelpers),
    initialValues: {
      CustomerProjectIDEncrypt: "",
      ProjectName: "",
      ManagementName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { CustomerProjectIDEncrypt },
  } = formikCustomerProjectNameAdd;

  const handleValidSubmitCustomerProjectNameAdd = (values) => {
    // setIsLoading(true);
    // alert(CustomerProjectIDEncrypt);

    let payload = {
      ...values,
      CustomerProjectIDEncrypt: CustomerProjectIDEncrypt,
      CustomerIDEncrypt: CustomerIDEncrypt, //PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      ProjectName: values.ProjectName.trim(),
      ManagementName: values.ManagementName.trim(),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      CustomerProjectIDEncrypt
        ? POST_CustomerProjectsUpdate
        : POST_CustomerProjectsInsert,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            //loadCustomerProjectDDL();
            setAddProjectNameModal(false);
            setManagementName("");

            if (CustomerProjectIDEncrypt) {
              setCustomerProjectListOptions(
                customerProjectListOptions.map((item) => {
                  if (item?.value == CustomerProjectIDEncrypt) {
                    return {
                      ...item,
                      label: values?.ProjectName,
                    };
                  } else {
                    return {
                      ...item,
                    };
                  }
                }),
              );

              formikCustomerProjectDetail.setFieldValue(
                "ProjectName",
                values?.ProjectName,
              );

              formikCustomerProjectDetail.setFieldValue(
                "ManagementName",
                values?.ManagementName.trim(),
              );
              //setProjectName(e?.label);
              setManagementName(values?.ManagementName.trim());
            } else {
              setCustomerProjectListOptions([
                ...customerProjectListOptions,
                {
                  label: values?.ProjectName.trim(),
                  value: response?.EncryptID,
                },
              ]);
            }

            if (projectTypeShowFlag === 1) {
              formikCustomerProjectDetail.setFieldValue(
                "CustomerProjectID",
                CustomerProjectIDEncrypt
                  ? CustomerProjectIDEncrypt
                  : response?.EncryptID,
              );
            } else {
              if (CustomerProjectIDEncrypt) {
                formikCustomerContactPersonsDetail.setFieldValue(
                  "CPDCustomerProjectID",
                  CustomerProjectIDEncrypt,
                );
              } else {
                formikCustomerContactPersonsDetail.setFieldValue(
                  "CPDCustomerProjectID",
                  [
                    ...CPDCustomerProjectID,
                    {
                      label: values?.ProjectName.trim(),
                      value: response?.EncryptID,
                    },
                  ],
                );
              }
              // formikCustomerContactPersonsDetail.setFieldValue(
              //   "CPDCustomerProjectID",
              //   CustomerProjectIDEncrypt
              //     ? CustomerProjectIDEncrypt
              //     : response?.EncryptID
              // );
            }

            //setProjectName("");
            formikCustomerProjectNameAdd.setFieldValue("CustomerProjectID", "");
          }, 1000);
          setIsLoading(false);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CountryID) {
      getStateDDL(CountryID);
    } else {
      setStateOptions([]);
      formikCustomerProjectDetail.setFieldValue("StateID", "");
    }
  }, [CountryID]);

  useEffect(() => {
    if (StateID) {
      getCityDDL(StateID);
    } else {
      setCityOptions([]);
      formikCustomerProjectDetail.setFieldValue("CityID", "");
    }
  }, [StateID]);

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 1) {
      setCountryOptions([
        ...countryOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikCustomerProjectDetail.setFieldValue("CountryID", categoryID);
      formikCustomerProjectDetail.setFieldValue("CountryName", categoryName);
    } else if (categoryType == 2) {
      setStateOptions([
        ...stateOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikCustomerProjectDetail.setFieldValue("StateID", categoryID);
      formikCustomerProjectDetail.setFieldValue("StateName", categoryName);
    } else if (categoryType == 3) {
      setCityOptions([
        ...cityOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikCustomerProjectDetail.setFieldValue("CityID", categoryID);
      formikCustomerProjectDetail.setFieldValue("CityName", categoryName);
    } else if (categoryType == 5) {
      setDesignationOptions([
        ...designationOptions,
        { label: categoryName, value: categoryID },
      ]);
      formikCustomerContactPersonsDetail.setFieldValue(
        "CPDDesignation",
        categoryID,
      );
      formikCustomerContactPersonsDetail.setFieldValue(
        "DesignationName",
        categoryName,
      );
    }
  };

  const addProjectContactPersonDetail = () => {
    setStampImageFile(null);
    setStampImage(null);
    formikCustomerContactPersonsDetail.resetForm();
    /*select the value when there is only one option while insert only*/
    if (customerProjectListOptions?.length == 1) {
      formikCustomerContactPersonsDetail.setFieldValue("CPDCustomerProjectID", [
        {
          label: customerProjectListOptions[0]?.label,
          value: customerProjectListOptions[0]?.value,
        },
      ]);
    }
    if (designationOptions?.length == 1) {
      formikCustomerContactPersonsDetail.setFieldValue(
        "CPDDesignation",
        designationOptions[0]?.value,
      );
      formikCustomerContactPersonsDetail.setFieldValue(
        "DesignationName",
        designationOptions[0]?.label,
      );
    }
    setAddContactPersonsDetailModal(true);
  };

  const editProjectContactPersonDetail = (ID) => {
    if (ID) {
      post(POST_GetCustomerContactPersonDetailByID, {
        CustomerContactPersonIDEncrypt: ID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let listOfProject = response?.ListOfProject;
            formikCustomerContactPersonsDetail.setValues({
              ...response,
              //CPDCustomerProjectID: response?.CustomerProjectIDs,
              CPDCustomerProjectID:
                listOfProject.length > 0
                  ? listOfProject.map((x) => ({
                      label: x.ProjectName,
                      value: x.CustomerProjectIDEncrypt,
                      ManagementName: x.ManagementName,
                    }))
                  : "",

              CustomerContactPersonIDEncrypt:
                response?.CustomerContactPersonIDEncrypt,
              CPDContactPerson: response?.ContactPerson,
              CPDCountryCode: response?.CountryCode,
              CPDContactPerson: response?.ContactPerson,
              CPDCountryCode: response?.CountryCode,
              CPDMobileNo: response?.MobileNo,
              CPDEmailID: response?.EmailID,
              CPDIsBilling: response?.IsBilling,
              CPDIsReporting: response?.IsReporting,
              CPDIsDispatch: response?.IsDispatch,
              CPDIsDispatchMaterial: response?.IsDispatchMaterial,
              CPDStempWriteup: response?.StempWriteup,
              CPDStempImageURL: response?.StempImageFilePath,
              CPDDesignation: response?.Designation,
              CPDIsActive: response?.IsActive,
              CPDTelephoneNo: response?.TelephoneNo,
            });
            setStampImage(response?.StempImageFilePath);
          }
          setIsLoading(false);
          setAddContactPersonsDetailModal(true);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };

  const validationSchemaCustomerContactPersonsDetail = Yup.object().shape({
    CPDCustomerProjectID: Yup.array()
      .nullable()
      .required("Project is required field"),
    CPDContactPerson: Yup.string()
      .trim()
      .required("Contact Person is required field"),
    // CPDDesignation: Yup.string()
    //   .trim()
    //   .required("Designation is required field"),
    // CPDEmailID: Yup.string().trim().required("Email is required field"),
    // CPDMobileNo: Yup.string().trim().required("Mobile No is required field"),
  });

  const formikCustomerContactPersonsDetail = useFormik({
    validationSchema: validationSchemaCustomerContactPersonsDetail,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCustomerContactPersonsDetail(values, formikHelpers),
    initialValues: {
      CustomerIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",

      CustomerContactPersonIDEncrypt: "",
      CustomerProjectContactPersonIDEncrypt: "",
      CPDCustomerProjectID: "",
      CPDContactPerson: "",
      CPDCountryCode: "+91",
      CPDMobileNo: "",
      MobileNoFormat: "",
      CPDEmailID: "",
      CPDIsBilling: false,
      CPDIsReporting: false,
      CPDIsDispatch: false,
      CPDIsDispatchMaterial: false,
      CPDStempWriteup: "",
      CPDStempImageURL: "",
      CPDDesignation: "",
      CPDIsActive: true,
      ProjectName: "",
      ManagementName: "",
      DesignationName: "",
      CPDTelephoneNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      CPDCustomerProjectID,
      CPDCountryCode,
      CPDIsBilling,
      CPDIsReporting,
      CPDIsDispatch,
      CPDIsDispatchMaterial,
      CPDDesignation,
      CPDIsActive,
      CustomerContactPersonIDEncrypt,
      CustomerProjectContactPersonIDEncrypt,
    },
  } = formikCustomerContactPersonsDetail;

  const handleValidSubmitCustomerContactPersonsDetail = (values) => {
    //setIsLoading(true);
    if (
      CPDIsBilling === false &&
      CPDIsReporting === false &&
      CPDIsDispatch === false &&
      CPDIsDispatchMaterial === false
    ) {
      // swal({
      //   title: "warning",
      //   text: "atleast one checkbox check (Billing/Reporting/Dispatch/Dispatch Material)",
      //   icon: "warning",
      //   button: "OK",
      // });
      warningMessage(
        //"Please select one option from (Billing / Reporting / Dispatch / Dispatch Material)"
        `Please select one option from (Billing / Reporting ${
          AuthUser?.Permissions?.DispatchReport == 1 ? "/ Dispatch" : ""
        } ${
          AuthUser?.Permissions?.DispatchMaterial == 1
            ? "/ Dispatch Material"
            : ""
        })`,
      );
      return;
      //setIsLoading(false);
    }
    if (values?.CPDMobileNo) {
      if (
        !validateMobileNoField(
          values?.MobileNoFormat,
          CPDCountryCode,
          values?.CPDMobileNo,
        )
      ) {
        formikCustomerContactPersonsDetail.setFieldError(
          "CPDMobileNo",
          "Please enter a valid mobile number",
        );
        formikCustomerContactPersonsDetail.setFieldTouched("CPDMobileNo", true);
        return false;
      }
    }

    let formData = new FormData();

    formData.append(
      "CustomerContactPersonIDEncrypt",
      values.CustomerContactPersonIDEncrypt,
    );
    formData.append("CustomerIDEncrypt", CustomerIDEncrypt);
    formData.append(
      "CustomerProjectIDs",
      Array.from(values.CPDCustomerProjectID, (x) => x.value).join(","),
    );
    formData.append("ContactPerson", values.CPDContactPerson);
    formData.append(
      "CountryCode",
      "+" + values.CPDCountryCode.replace(/\+/g, ""),
    );
    formData.append("MobileNo", values.CPDMobileNo);
    formData.append("EmailID", values.CPDEmailID);
    formData.append("IsBilling", values.CPDIsBilling);
    formData.append("IsReporting", values.CPDIsReporting);
    formData.append("IsDispatch", values.CPDIsDispatch);
    formData.append("IsDispatchMaterial", values.CPDIsDispatchMaterial);
    formData.append("StempWriteup", values.CPDStempWriteup);
    formData.append(
      "Designation",
      values?.CPDDesignation ? values?.CPDDesignation : 0,
    );
    formData.append("StempImageFilePathURL", values?.CPDStempImageURL);
    formData.append("StempImageFilePath", stampImageFile);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append("IsActive", values?.CPDIsActive ? 1 : 0);
    formData.append("TelephoneNo", values.CPDTelephoneNo);

    //console.log("Add", formData);

    postFormData(
      CustomerContactPersonIDEncrypt
        ? POST_CustomerContactPersonDetailUpdate
        : POST_CustomerContactPersonDetailInsert,
      formData,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            LoadData(CustomerIDEncrypt);
            formikCustomerContactPersonsDetail.resetForm();
            setAddContactPersonsDetailModal(false);
          }, 1000);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadStampImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setStampImageFile(null);
        setStampImage(null);
        // swal("", "Select valid image file!", "warning");
        warningMessage("Select valid image file!");
      } else {
        setStampImageFile(file);
        setStampImage(URL.createObjectURL(file));
        setValidationStampImage("");
      }
    }
  };

  const closeTab = (tp) => {
    let msg = "";

    if (CustomerIDEncrypt) {
      msg = "Are you sure you want to Close?";
    } else {
      msg = "Are you sure you want to Cancel?";
    }

    if (tp == 2) {
      swal({
        title: msg,
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        buttons: ["No", "Yes"],
      }).then((confirmResult) => {
        if (confirmResult) {
          window.opener = null;
          window.open("", "_self");
          window.close();
        }
      });
    } else {
      swal({
        title: `Record has been Inserted successfully`,
        text: "",
        icon: "success",
        buttons: true,
        dangerMode: true,
        buttons: "OK",
      }).then((confirmResult) => {
        if (confirmResult) {
          window.opener = null;
          window.open("", "_self");
          window.close();
        }
      });
    }
  };

  const handleChangeGSTRegistrationType = (e) => {
    formik.setFieldValue("GSTRegistrationType", e?.value ?? "");
    if (e && e?.value != 1) {
      formik.setFieldValue("GSTNo", "");
      formik.setFieldError("GSTNo", "");
      formik.setFieldTouched("GSTNo", false);
      formik.setFieldValue("CustomerInSEZ", false);
      formik.setFieldValue("GSTSEZType", 0);
      formik.setFieldValue("ExemptionFromDate", "");
      formik.setFieldValue("ExemptionToDate", "");
      formik.setFieldValue("ExemptionDocFile", "");
      // formik.setFieldValue("ExemptionDocFilePath", "");
    }
  };

  const handleChangeCustomerInSEZ = (e) => {
    formik.setFieldValue("CustomerInSEZ", e.target.checked);
  };

  // useEffect(() => {
  //   if (ExemptionToDate && ExemptionToDate < ExemptionFromDate) {
  //     formik.setFieldValue("ExemptionToDate", ExemptionFromDate);
  //   }
  //   if (!ExemptionFromDate) {
  //     formik.setFieldValue("ExemptionFromDate", "");
  //   }
  // }, [ExemptionFromDate]);

  // useEffect(() => {
  //   if (!ExemptionToDate) {
  //     formik.setFieldValue("ExemptionToDate", "");
  //   }
  // }, [ExemptionToDate]);

  const uploadExemptionDocFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern =
        /^(application\/(msword|vnd\.openxmlformats-officedocument\.wordprocessingml\.document)|application\/pdf|image\/(jpeg|png|gif))$/i;

      if (!file.type.match(pattern)) {
        formik.setFieldValue(
          "ExemptionDocFileKey",
          Math.random().toString(9).substring(2, 9),
        );
        formik.setFieldValue("ExemptionDocFile", "");
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue("ExemptionDocFile", file);
      }
    } else {
      formik.setFieldValue("ExemptionDocFile", "");
      formik.setFieldValue(
        "ExemptionDocFileKey",
        Math.random().toString(9).substring(2, 9),
      );
    }
  };

  const downloadExemptionDocFile = (e) => {
    window.open(
      ExemptionDocFile
        ? URL.createObjectURL(ExemptionDocFile)
        : ExemptionDocFilePath,
      "_blank",
    );
  };

  const deleteExemptionDocFile = (e) => {
    formik.setFieldValue("ExemptionDocFile", "");
    formik.setFieldValue(
      "ExemptionDocFileKey",
      Math.random().toString(9).substring(2, 9),
    );
    formik.setFieldValue("ExemptionDocFilePath", "");
  };

  const saveExemptionDocFile = async (customerID, values, successMsg) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append("CustomerIDEncrypt", customerID);
    formData.append(
      "ExemptionDocFile",
      values?.CustomerInSEZ == true ? values?.ExemptionDocFile : "",
    );
    formData.append(
      "ExemptionDocFilePathURL",
      values?.CustomerInSEZ == true ? values?.ExemptionDocFilePath : "",
    );

    await postFormData(POST_CustomerGSTExemptionDocFileSave, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(successMsg);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackChangeCredentials = () => {
    formik.setFieldValue("CustomerIDEncrypt", "");
  };

  const customConfirmResetCredentialsDialog = async (
    titleString,
    textString,
    fnCallback,
    callBackResultValue = false,
  ) => {
    swal({
      title: titleString,
      text: textString,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      //buttons: ["No", "Yes"],
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "btn-sm",
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "btn-sm",
          closeModal: true,
        },
      },
    }).then((willDo) => {
      if (willDo == callBackResultValue) {
        fnCallback();
      } else {
        setIsLoading(true);

        let payload = {
          CustomerIDEncrypt: CustomerIDEncrypt,
          CustomerName: CustomerName,
          EmailID: EmailID,
          UserName: UserName,
          CompanyName: AuthUser?.CompanyName,
          CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
          BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
          ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
            ? AuthUser?.ReferenceIDEncrypt
            : "0",
        };
        post(POST_CustomerRestPassword, payload)
          .then((response) => {
            setIsLoading(true);
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              if (PrimaryIdParam) {
                setTimeout(() => {
                  navigate("/customer");
                }, 1000);
              }
            } else {
              //swal("Error!", response?.Message, "error");
              errorMessage(response?.Message);
              setIsLoading(false);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    });
  };

  const customConfirmResetPasswordLinkDialog = async (
    titleString,
    textString,
    fnCallback,
    callBackResultValue = false,
  ) => {
    swal({
      title: titleString,
      text: textString,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      //buttons: ["No", "Yes"],
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "btn-sm",
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "btn-sm",
          closeModal: true,
        },
      },
    }).then((willDo) => {
      if (willDo == callBackResultValue) {
        fnCallback();
      } else {
        setIsLoading(true);

        let payload = {
          CustomerIDEncrypt: CustomerIDEncrypt,
          CustomerName: CustomerName,
          EmailID: EmailID,
          LoginFlag: LoginFlag,
          CompanyName: AuthUser?.CompanyName,
          CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
          BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
          ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
            ? AuthUser?.ReferenceIDEncrypt
            : "0",
        };
        post(POST_CustomerLoginLinkSend, payload)
          .then((response) => {
            setIsLoading(true);
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              if (PrimaryIdParam) {
                setTimeout(() => {
                  navigate("/customer");
                }, 1000);
              }
            } else {
              //swal("Error!", response?.Message, "error");
              errorMessage(response?.Message);
              setIsLoading(false);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <>
      <Fragment>
        <div className="card m-1">
          <div className="card-body p-1">
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <div className="tbl-caption p-2">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="heading mb-0">
                    {PrimaryIdParam ? "Edit" : "Add"} Customer
                  </h4>
                  {AuthUser?.IsBroadcastEmailSetup == false &&
                    AuthUser?.Permissions?.Email == 1 && (
                      <div className="text-danger">
                        Note: In Application setup - Broadcast Message Mail
                        Setting is pending. So user wan't be able to get
                        credential email.{" "}
                      </div>
                    )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0">
                <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col lg={CustomerIDEncrypt ? 6 : 12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <Row>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"Customer Name"}
                                  name="CustomerName"
                                  placeholder={"Enter Customer Name"}
                                  component={CustomInput}
                                  maxLength={250}
                                  required
                                  autoFocus
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "CustomerName",
                                      capitalizeString(e?.target?.value),
                                    );
                                  }}
                                />
                              </Col>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"Short Name"}
                                  name="ShortName"
                                  placeholder={"Enter Short Name"}
                                  component={CustomInput}
                                  maxLength={50}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "ShortName",
                                      capitalizeString(e?.target?.value),
                                    );
                                  }}
                                />
                              </Col>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"Vendor Code"}
                                  name="VendorCode"
                                  placeholder={"Enter Vendor Code"}
                                  component={CustomInput}
                                  maxLength={100}
                                />
                              </Col>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="email"
                                  label={"Email"}
                                  name="EmailID"
                                  placeholder={"Enter Email"}
                                  component={CustomInput}
                                  maxLength={100}
                                  // required
                                  validate={validateEmailField}
                                  onBlur={(e) => {
                                    if (LoginFlag) {
                                      formik.setFieldValue(
                                        "UserName",
                                        e?.target?.value ?? "",
                                      );
                                    } else {
                                      formik.setFieldValue("UserName", "");
                                    }
                                  }}
                                />
                              </Col>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  label="GST Registration Type"
                                  name="GSTRegistrationType"
                                  placeholder={"Select GST Registration Type"}
                                  options={gSTRegistrationTypeOptions}
                                  component={CustomSelect}
                                  onChange={handleChangeGSTRegistrationType}
                                  required
                                />
                              </Col>

                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"GST No"}
                                  name="GSTNo"
                                  placeholder={"Enter GST No"}
                                  component={CustomInput}
                                  disabled={
                                    GSTRegistrationType == 1 ? false : true
                                  }
                                  onChange={(e) => handleChangeGst(e)}
                                  // required
                                  maxLength={19}
                                />
                              </Col>

                              {GSTRegistrationType == 1 && (
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <label className="mb-1">
                                    Customer In SEZ &nbsp;
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      //key={indx}
                                      responsive={true}
                                      overlay={
                                        <Tooltip
                                          className="toltip-popover"
                                          // id={`popover-positioned-${item.InwardRejectRectifyReason.toLowerCase()}`}
                                        >
                                          <strong className="p-1">
                                            {" "}
                                            GST registerd in Special Economic
                                            Zone (SEZ)
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                  </label>
                                  <div className="mb-2 form-control form-control-sm">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="CustomerInSEZ"
                                      checked={CustomerInSEZ}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "CustomerInSEZ",
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label ms-2"
                                      htmlFor="CustomerInSEZ"
                                    >
                                      Customer GST Registered In SEZ
                                    </label>
                                  </div>
                                </Col>
                              )}

                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"Pan No"}
                                  name="PanNo"
                                  placeholder={"Enter Pan No"}
                                  component={CustomInput}
                                  maxLength={50}
                                />
                              </Col>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  label="Representative"
                                  name="CustomerRepresentativeIDEncrypt"
                                  placeholder={"Select Representative"}
                                  options={customerRepresentativeOptions}
                                  component={CustomSelect}
                                  //isClearable={false}
                                />
                              </Col>
                            </Row>
                            {AuthUser?.Permissions?.Account === 1 ? (
                              <Row>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <Field
                                    type="number"
                                    label={"Opening Balance (Current Branch)"}
                                    name="OpeningBalance"
                                    placeholder={
                                      "Enter Opening Balance (Debit)"
                                    }
                                    component={CustomInput}
                                    maxLength={20}
                                  />
                                </Col>

                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <Field
                                    label="Opening Balance Date (Current Branch)"
                                    name="OpeningBalanceDate"
                                    placeholder={"Select Opening Balance Date"}
                                    component={CustomFlatpickr}
                                    options={{
                                      altInput: true,
                                      altFormat: "j-M-Y",
                                      dateFormat: "d-m-Y",
                                    }}
                                  />
                                </Col>
                              </Row>
                            ) : (
                              ""
                            )}
                            {AuthUser?.Permissions?.Account === 1 ? (
                              <Row>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <label className="mb-1"> Cash Only</label>
                                  <div className="mb-2 form-control form-control-sm">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="IsCashOnly"
                                      checked={IsCashOnly}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "IsCashOnly",
                                          e.target.checked,
                                        );
                                        if (e.target.checked == true) {
                                          formik.setFieldValue(
                                            "IsDefaultCreditPeriodDays",
                                            false,
                                          );
                                          formik.setFieldValue(
                                            "IsSecurityCreditLimitRs",
                                            false,
                                          );
                                          formik.setFieldValue(
                                            "IsDefaultCreditPeriodDaysValue",
                                            "",
                                          );
                                          formik.setFieldValue(
                                            "IsSecurityCreditLimitRsValue",
                                            "",
                                          );
                                        }
                                      }}
                                    />
                                    <label
                                      className="form-check-label ms-2"
                                      htmlFor="IsCashOnly"
                                    >
                                      Cash Only
                                    </label>
                                  </div>
                                </Col>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <div className="mb-2">
                                    <label className="mb-1">
                                      Credit Period Days
                                    </label>
                                    <div className="input-group">
                                      <div className="input-group-text">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-0"
                                          id="IsDefaultCreditPeriodDays"
                                          checked={IsDefaultCreditPeriodDays}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              "IsDefaultCreditPeriodDays",
                                              e.target.checked,
                                            );
                                          }}
                                          disabled={IsCashOnly}
                                        />
                                      </div>
                                      <input
                                        type="number"
                                        name="IsDefaultCreditPeriodDaysValue"
                                        placeholder={"Credit Period Days"}
                                        autoComplete={"off"}
                                        className="form-control form-control-sm"
                                        value={IsDefaultCreditPeriodDaysValue}
                                        maxLength={20}
                                        disabled={IsCashOnly}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            "IsDefaultCreditPeriodDaysValue",
                                            e?.target?.value ?? "",
                                          );
                                        }}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name={"IsDefaultCreditPeriodDaysValue"}
                                      component="div"
                                      className="invalid-feedback animated fadeInUp"
                                      style={{ display: "block" }}
                                    />
                                  </div>
                                </Col>

                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <div className="mb-2">
                                    <label className="mb-1">
                                      Credit Limit Amount
                                    </label>
                                    <div className="input-group">
                                      <div className="input-group-text">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mt-0"
                                          id="IsSecurityCreditLimitRs"
                                          checked={IsSecurityCreditLimitRs}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              "IsSecurityCreditLimitRs",
                                              e.target.checked,
                                            );
                                          }}
                                          disabled={IsCashOnly}
                                        />
                                      </div>

                                      <input
                                        type="number"
                                        name="IsSecurityCreditLimitRsValue"
                                        placeholder={"Credit Limit Amount"}
                                        autoComplete={"off"}
                                        className="form-control form-control-sm"
                                        value={IsSecurityCreditLimitRsValue}
                                        maxLength={20}
                                        disabled={IsCashOnly}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            "IsSecurityCreditLimitRsValue",
                                            e?.target?.value ?? "",
                                          );
                                        }}
                                      />
                                    </div>
                                    <ErrorMessage
                                      name={"IsSecurityCreditLimitRsValue"}
                                      component="div"
                                      className="invalid-feedback animated fadeInUp"
                                      style={{ display: "block" }}
                                    />
                                  </div>
                                </Col>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <Field
                                    label="Invoice Format Type"
                                    name="InvoiceFormatType"
                                    placeholder={"Select Invoice Format Type"}
                                    options={invoiceFormatTypeOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                  />
                                </Col>
                              </Row>
                            ) : (
                              ""
                            )}
                            {/* <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <label className="mb-1"> Credit Period Days</label>
                                <div className="mb-2 form-control form-control-sm">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="IsDefaultCreditPeriodDays"
                                    checked={IsDefaultCreditPeriodDays}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "IsDefaultCreditPeriodDays",
                                        e.target.checked
                                      );
                                    }}
                                    disabled={IsCashOnly}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="IsDefaultCreditPeriodDays"
                                  >
                                    Credit Period Days
                                  </label>
                                </div>
                              </Col> */}

                            {/* <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <label className="mb-1"> Credit Limit Amount</label>
                                <div className="mb-2 form-control form-control-sm">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="IsSecurityCreditLimitRs"
                                    checked={IsSecurityCreditLimitRs}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "IsSecurityCreditLimitRs",
                                        e.target.checked
                                      );
                                    }}
                                    disabled={IsCashOnly}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="IsSecurityCreditLimitRs"
                                  >
                                    Credit Limit Amount
                                  </label>
                                </div>
                              </Col> */}
                            {/* <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={" Credit Period Days Value"}
                                  name="IsDefaultCreditPeriodDaysValue"
                                  placeholder={"Credit Period Days Value"}
                                  component={CustomInput}
                                  maxLength={20}
                                  disabled={IsCashOnly}
                                />
                              </Col> */}
                            {/* <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <Field
                                  type="text"
                                  label={"Credit Limit Amount"}
                                  name="IsSecurityCreditLimitRsValue"
                                  placeholder={
                                    "Enter Credit Limit Amount"
                                  }
                                  component={CustomInput}
                                  maxLength={20}
                                  disabled={IsCashOnly}
                                />
                              </Col> */}
                            {/* </Row> */}
                            <Row>
                              <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                <label className="mb-1">Is TPI</label>
                                <div className="mb-2 form-control form-control-sm">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="IsTPI"
                                    checked={IsTPI}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "IsTPI",
                                        e.target.checked,
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="IsTPI"
                                  >
                                    Is TPI
                                  </label>
                                </div>
                              </Col>
                              {AuthUser?.Permissions?.Account == 1 ? (
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <label className="mb-1">
                                    Proforma Invoice Required
                                  </label>
                                  <div className="mb-2 form-control form-control-sm">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="PerformaInvoiceRequired"
                                      checked={PerformaInvoiceRequired}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "PerformaInvoiceRequired",
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label ms-2"
                                      htmlFor="PerformaInvoiceRequired"
                                    >
                                      Proforma Invoice Required
                                    </label>
                                  </div>
                                </Col>
                              ) : (
                                ""
                              )}
                            </Row>
                            <hr className="mt-0 mb-1"></hr>
                            <Row>
                              {AuthUser?.Permissions?.CustomerLogin == 1 ? (
                                <>
                                  <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                    {CustomerIDEncrypt &&
                                    LoginFlag &&
                                    AuthUser?.Permissions?.Email == 1 &&
                                    LoginIDEncrypt &&
                                    UserName ? (
                                      <Link
                                        to="#"
                                        title="Send Reset Password Link"
                                        className="text-primary"
                                        style={{ float: "right" }}
                                        onClick={() => {
                                          customConfirmResetPasswordLinkDialog(
                                            "Reset Password Link in Email",
                                            "Do you want to continue?",
                                            fnCallbackChangeCredentials,
                                            false,
                                          );
                                        }}
                                      >
                                        Resend Link
                                      </Link>
                                    ) : (
                                      ""
                                    )}
                                    <label className="mb-1">
                                      Customer Login
                                    </label>
                                    <div className="mb-2 form-control form-control-sm">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="LoginFlag"
                                        checked={LoginFlag}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            "LoginFlag",
                                            e.target.checked,
                                          );
                                          if (e?.target?.checked) {
                                            formik.setFieldValue(
                                              "IsInward",
                                              true,
                                            );
                                          } else {
                                            formik.setFieldValue(
                                              "IsInward",
                                              false,
                                            );
                                          }
                                        }}
                                      />
                                      <label
                                        className="form-check-label ms-2"
                                        htmlFor="LoginFlag"
                                      >
                                        Customer Login
                                      </label>
                                    </div>
                                  </Col>
                                  {LoginFlag == true ? (
                                    <>
                                      <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                        {CustomerIDEncrypt &&
                                        UserName &&
                                        AuthUser?.Permissions?.Email == 1 &&
                                        LoginIDEncrypt ? (
                                          <Link
                                            to="#"
                                            title="Resend Credentials"
                                            className="text-primary"
                                            style={{ float: "right" }}
                                            onClick={() => {
                                              customConfirmResetCredentialsDialog(
                                                "Credentials Send in Email",
                                                "Do you want to continue?",
                                                fnCallbackChangeCredentials,
                                                false,
                                              );
                                            }}
                                          >
                                            Resend Credentials
                                          </Link>
                                        ) : (
                                          ""
                                        )}
                                        <Field
                                          type="text"
                                          label={"User Name"}
                                          name="UserName"
                                          placeholder={"Enter UserName"}
                                          component={CustomInput}
                                          maxLength={20}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                        <label className="mb-1">Inward</label>
                                        <div className="mb-2 form-control form-control-sm">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="IsInward"
                                            checked={IsInward}
                                            disabled={true}
                                          />
                                          <label
                                            className="form-check-label ms-2"
                                            htmlFor="IsInward"
                                          >
                                            Inward
                                          </label>
                                        </div>
                                      </Col>
                                      <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                        <label className="mb-1">Invoice</label>
                                        <div className="mb-2 form-control form-control-sm">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="IsInvoice"
                                            checked={IsInvoice}
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                "IsInvoice",
                                                e?.target?.checked,
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label ms-2"
                                            htmlFor="IsInvoice"
                                          >
                                            Invoice
                                          </label>
                                        </div>
                                      </Col>
                                      <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                        <label className="mb-1">Ledger</label>
                                        <div className="mb-2 form-control form-control-sm">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="IsLedger"
                                            checked={IsLedger}
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                "IsLedger",
                                                e?.target?.checked,
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label ms-2"
                                            htmlFor="IsLedger"
                                          >
                                            Ledger
                                          </label>
                                        </div>
                                      </Col>
                                      <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                        <label className="mb-1">
                                          Outstanding
                                        </label>
                                        <div className="mb-2 form-control form-control-sm">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="IsOutstanding"
                                            checked={IsOutstanding}
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                "IsOutstanding",
                                                e?.target?.checked,
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label ms-2"
                                            htmlFor="IsOutstanding"
                                          >
                                            Outstanding
                                          </label>
                                        </div>
                                      </Col>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </Row>
                          </div>
                        </div>
                        {CustomerInSEZ == true && (
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-header p-2">
                              <h6 className="card-title">Exemption Detail</h6>
                            </div>
                            <div className="card-body p-2">
                              <Row>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <label className="mb-1">
                                    GST SEZ Type
                                    <i className="text-danger">*</i>&nbsp;
                                    <OverlayTrigger
                                      trigger={["hover", "focus"]}
                                      //key={indx}
                                      responsive={true}
                                      overlay={
                                        <Tooltip
                                          className="toltip-popover"
                                          // id={`popover-positioned-${item.InwardRejectRectifyReason.toLowerCase()}`}
                                        >
                                          <strong className="p-1">
                                            {" "}
                                            "SEZ With Payment" - GST will be
                                            calculate <br></br>
                                            "SEZ Without Payment" - GST not
                                            calculate
                                          </strong>
                                        </Tooltip>
                                      }
                                    >
                                      <span>
                                        <i
                                          className="fa fa-info-circle"
                                          style={{
                                            cursor: "pointer",
                                            color: "#9698ab",
                                          }}
                                        ></i>
                                      </span>
                                    </OverlayTrigger>
                                  </label>
                                  <Field
                                    //label="GST SEZ Type"
                                    name="GSTSEZType"
                                    placeholder={"Select GST SEZ Type"}
                                    options={gstSEZTypeOptions}
                                    component={CustomSelect}
                                    required
                                  />
                                </Col>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  {(ExemptionDocFile ||
                                    ExemptionDocFilePath) && (
                                    <>
                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md me-1"
                                        title="Delete"
                                        style={{ float: "right" }}
                                        onClick={deleteExemptionDocFile}
                                      >
                                        {SVGICON.DeleteDanger}
                                      </Link>
                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md me-1"
                                        title="Download"
                                        style={{ float: "right" }}
                                        onClick={downloadExemptionDocFile}
                                      >
                                        {SVGICON.Download}
                                      </Link>
                                    </>
                                  )}
                                  <div className="mb-2">
                                    <label className="mb-1">
                                      Exemption Doc
                                    </label>
                                    <input
                                      type="file"
                                      className="form-control form-control-sm"
                                      id="ExemptionDocFile"
                                      accept=".doc,.docx,.pdf,image/jpeg,image/png,image/gif"
                                      key={ExemptionDocFileKey || ""}
                                      onChange={(e) => {
                                        uploadExemptionDocFile(e);
                                      }}
                                    />
                                  </div>
                                </Col>
                                {/* <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <Field
                                    label="Exemption From Date"
                                    name="ExemptionFromDate"
                                    placeholder={"Select Exemption From Date"}
                                    component={CustomFlatpickr}
                                    options={{
                                      altInput: true,
                                      altFormat: "j-M-Y",
                                      dateFormat: "d-m-Y",
                                    }}
                                    required
                                  />
                                </Col>
                                <Col lg={CustomerIDEncrypt ? 6 : 3}>
                                  <Field
                                    label="Exemption To Date"
                                    name="ExemptionToDate"
                                    placeholder={"Select Exemption To Date"}
                                    component={CustomFlatpickr}
                                    options={{
                                      altInput: true,
                                      altFormat: "j-M-Y",
                                      dateFormat: "d-m-Y",
                                      minDate: ExemptionFromDate,
                                    }}
                                    required
                                  />
                                </Col> */}
                              </Row>
                            </div>
                          </div>
                        )}
                      </Col>
                      {CustomerIDEncrypt ? (
                        <>
                          <Col lg={6}>
                            <Row>
                              <Col lg={12}>
                                <div
                                  className="card mb-2"
                                  style={{ height: "auto" }}
                                >
                                  <div className="card-header p-2">
                                    <h4 className="card-title">
                                      Project Details
                                    </h4>
                                    <Link
                                      to="#"
                                      title="New Project"
                                      className="text-primary"
                                      style={{ float: "right" }}
                                      onClick={addProjectDetail}
                                    >
                                      + Add Project Detail
                                    </Link>
                                  </div>
                                  <div className="card-body p-2">
                                    <div className="basic-form">
                                      <Accordion
                                        className="accordion accordion-primary"
                                        defaultActiveKey="0"
                                      >
                                        {customerProjectAddressList?.length > 0
                                          ? customerProjectAddressList?.map(
                                              (item, index) => (
                                                <Accordion.Item
                                                  className="accordion-item"
                                                  key={index}
                                                  eventKey={index}
                                                >
                                                  <Accordion.Header className="accordion-header rounded-lg">
                                                    <Link
                                                      to="#"
                                                      className={`icon-box icon-box-md me-1`}
                                                      title={
                                                        item?.IsActiveProject ===
                                                        true
                                                          ? "Project Active"
                                                          : "Project Inactive"
                                                      }
                                                      onClick={() => {
                                                        ActiveInactive_Record(
                                                          item?.IsActiveProject,
                                                          POST_CustomerProjectsActiveInActive,
                                                          {
                                                            CustomerProjectIDEncrypt:
                                                              item?.CustomerProjectIDEncrypt,
                                                            IsActive:
                                                              !item?.IsActiveProject,
                                                            ModifiedByEncrypted:
                                                              AuthUser?.ReferenceIDEncrypt
                                                                ? AuthUser?.ReferenceIDEncrypt
                                                                : "0",
                                                          },
                                                          setIsLoading,
                                                          fnCallback,
                                                          item?.ProjectName,
                                                        );
                                                      }}
                                                    >
                                                      <i
                                                        className={`fa fa-circle fs-15 ${
                                                          item?.IsActiveProject ==
                                                          true
                                                            ? "text-success"
                                                            : "text-danger"
                                                        }`}
                                                      ></i>
                                                    </Link>
                                                    <b>Project Name : </b>{" "}
                                                    &nbsp;
                                                    {item?.ProjectName}, &nbsp;
                                                    <b>
                                                      {" "}
                                                      Management Name :{" "}
                                                    </b>{" "}
                                                    &nbsp;{item?.ManagementName}
                                                  </Accordion.Header>
                                                  <Accordion.Collapse
                                                    eventKey={index}
                                                  >
                                                    <div
                                                      className="accordion-body"
                                                      style={{
                                                        height: "180px",
                                                        overflowX: "auto",
                                                      }}
                                                    >
                                                      {item?.ListOfCustomerProjectsAddressDetailList?.map(
                                                        (subitem, subidx) => (
                                                          <div key={subidx}>
                                                            <div className="row">
                                                              <Row>
                                                                <Col lg={6}>
                                                                  <Link
                                                                    to="#"
                                                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                                                    className="icon-box icon-box-md me-1"
                                                                    title="Edit"
                                                                    onClick={() => {
                                                                      editProjectAddress(
                                                                        subitem.CustomerProjectAddressIDEncrypt,
                                                                      );
                                                                    }}
                                                                  >
                                                                    {
                                                                      SVGICON.EditPrimary
                                                                    }
                                                                  </Link>
                                                                  <Link
                                                                    to="#"
                                                                    // className={`icon-box icon-box-md bg-${
                                                                    //   subitem.IsActive ===
                                                                    //   true
                                                                    //     ? "success"
                                                                    //     : "danger"
                                                                    // }-light me-1`}
                                                                    className={`icon-box icon-box-md me-1`}
                                                                    title={
                                                                      subitem.IsActive ===
                                                                      true
                                                                        ? "Active"
                                                                        : "Inactive"
                                                                    }
                                                                    onClick={() => {
                                                                      ActiveInactive_Record(
                                                                        subitem.IsActive,
                                                                        POST_CustomerProjectAddressActiveInActive,
                                                                        {
                                                                          CustomerProjectAddressIDEncrypt:
                                                                            subitem.CustomerProjectAddressIDEncrypt,
                                                                          IsActive:
                                                                            !subitem.IsActive,
                                                                          ModifiedByEncrypted:
                                                                            AuthUser?.ReferenceIDEncrypt
                                                                              ? AuthUser?.ReferenceIDEncrypt
                                                                              : "0",
                                                                        },
                                                                        setIsLoading,
                                                                        fnCallback,
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i
                                                                      className={`fa fa-circle fs-15 ${
                                                                        subitem.IsActive ===
                                                                        true
                                                                          ? "text-success"
                                                                          : "text-danger"
                                                                      }`}
                                                                    ></i>
                                                                  </Link>
                                                                  {/* <Link
                                                                to="#"
                                                                className="icon-box icon-box-md bg-danger-light"
                                                                title="Delete"
                                                                onClick={() => {
                                                                  delete_Record(
                                                                    POST_CustomerProjectAddressDelete,
                                                                    {
                                                                      CustomerProjectAddressIDEncrypt:
                                                                        item.CustomerProjectAddressIDEncrypt,
                                                                      ModifiedByEncrypted:
                                                                        AuthUser?.ReferenceIDEncrypt,
                                                                    },
                                                                    setIsLoading,
                                                                    fnCallback
                                                                  );
                                                                }}
                                                              >
                                                                {
                                                                  SVGICON.DeleteDanger
                                                                }
                                                              </Link> */}
                                                                </Col>
                                                              </Row>
                                                              <div className="col-xl-12 col-lg-12">
                                                                <div className="row">
                                                                  <div className="col-xl-12 col-lg-12">
                                                                    <div className="c-card-details">
                                                                      <ul>
                                                                        <li>
                                                                          <h6>
                                                                            Address&nbsp;:{" "}
                                                                          </h6>
                                                                          <span>
                                                                            &nbsp;
                                                                            {
                                                                              subitem.Address
                                                                            }
                                                                          </span>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                  <div className="col-xl-4 col-lg-4">
                                                                    <div className="c-card-details">
                                                                      <ul>
                                                                        <li>
                                                                          <h6>
                                                                            City
                                                                            :
                                                                          </h6>
                                                                          <span className="ms-1">
                                                                            {subitem.CityName
                                                                              ? subitem.CityName
                                                                              : "-"}
                                                                          </span>
                                                                        </li>
                                                                        <li>
                                                                          <h6>
                                                                            Billing
                                                                            :
                                                                          </h6>
                                                                          <span className="ms-1">
                                                                            {subitem.IsBilling
                                                                              ? "Yes"
                                                                              : "No"}
                                                                          </span>
                                                                        </li>
                                                                        {AuthUser
                                                                          ?.Permissions
                                                                          ?.DispatchMaterial ==
                                                                          1 && (
                                                                          <li>
                                                                            <h6>
                                                                              Dispatch
                                                                              Material
                                                                              :
                                                                            </h6>
                                                                            <span className="ms-1">
                                                                              {subitem.IsDispatchMaterial
                                                                                ? "Yes"
                                                                                : "No"}
                                                                            </span>
                                                                          </li>
                                                                        )}
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                  <div className="col-xl-4 col-lg-4">
                                                                    <div className="c-card-details">
                                                                      <ul>
                                                                        <li>
                                                                          <h6>
                                                                            State
                                                                            :
                                                                          </h6>
                                                                          <span className="ms-1">
                                                                            {subitem.StateName
                                                                              ? subitem.StateName
                                                                              : "-"}
                                                                          </span>
                                                                        </li>
                                                                        <li>
                                                                          <h6>
                                                                            Reporting
                                                                            :
                                                                          </h6>
                                                                          <span className="ms-1">
                                                                            {subitem.IsReporting
                                                                              ? "Yes"
                                                                              : "No"}
                                                                          </span>
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                  <div className="col-xl-4 col-lg-4">
                                                                    <div className="c-card-details">
                                                                      <ul>
                                                                        <li>
                                                                          <h6>
                                                                            Country
                                                                            :
                                                                          </h6>
                                                                          <span className="ms-1">
                                                                            {subitem.CountryName
                                                                              ? subitem.CountryName
                                                                              : "-"}
                                                                          </span>
                                                                        </li>
                                                                        {AuthUser
                                                                          ?.Permissions
                                                                          ?.DispatchReport ==
                                                                          1 && (
                                                                          <li>
                                                                            <h6>
                                                                              Dispatch
                                                                              Report
                                                                              :
                                                                            </h6>
                                                                            <span className="ms-1">
                                                                              {subitem.IsDispatchReport
                                                                                ? "Yes"
                                                                                : "No"}
                                                                            </span>
                                                                          </li>
                                                                        )}
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                            <hr className="mt-0"></hr>
                                                          </div>
                                                        ),
                                                      )}
                                                    </div>
                                                  </Accordion.Collapse>
                                                </Accordion.Item>
                                              ),
                                            )
                                          : ""}
                                      </Accordion>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={12}>
                                <div
                                  className="card mb-2"
                                  style={{ height: "auto" }}
                                >
                                  <div className="card-header p-2">
                                    <h4 className="card-title">
                                      Project Contact Person Detail
                                    </h4>
                                    <Link
                                      to="#"
                                      className="text-primary"
                                      title="New Project"
                                      style={{ float: "right" }}
                                      onClick={addProjectContactPersonDetail}
                                    >
                                      + Add Contact Detail
                                    </Link>
                                  </div>
                                  <div className="card-body p-2">
                                    <div className="basic-form">
                                      <Accordion
                                        className="accordion accordion-primary"
                                        defaultActiveKey="0"
                                      >
                                        {customerProjectContactPersonList?.length >
                                        0
                                          ? customerProjectContactPersonList?.map(
                                              (subitem, index) => (
                                                <Accordion.Item
                                                  className="accordion-item"
                                                  key={index}
                                                  eventKey={index}
                                                >
                                                  <Accordion.Header className="accordion-header rounded-lg">
                                                    <b>Project Name : </b>{" "}
                                                    &nbsp;
                                                    {subitem.ProjectName},
                                                    &nbsp;
                                                    <b>
                                                      {" "}
                                                      Contact Person :{" "}
                                                    </b>{" "}
                                                    &nbsp;
                                                    {subitem.ContactPerson}
                                                  </Accordion.Header>
                                                  <Accordion.Collapse
                                                    eventKey={index}
                                                  >
                                                    <div
                                                      className="accordion-body"
                                                      style={{
                                                        height: "180px",
                                                        overflowX: "auto",
                                                      }}
                                                    >
                                                      <div className="row">
                                                        <Row>
                                                          <Col lg={6}>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Edit"
                                                              onClick={() => {
                                                                editProjectContactPersonDetail(
                                                                  subitem.CustomerContactPersonIDEncrypt,
                                                                );
                                                              }}
                                                            >
                                                              {
                                                                SVGICON.EditPrimary
                                                              }
                                                            </Link>
                                                            <Link
                                                              to="#"
                                                              // className={`icon-box icon-box-md bg-${
                                                              //   subitem.IsActive ===
                                                              //   true
                                                              //     ? "success"
                                                              //     : "danger"
                                                              // }-light me-1`}
                                                              className={`icon-box icon-box-md me-1`}
                                                              title={
                                                                subitem.IsActive ===
                                                                true
                                                                  ? "Active"
                                                                  : "Inactive"
                                                              }
                                                              onClick={() => {
                                                                ActiveInactive_Record(
                                                                  subitem.IsActive,
                                                                  POST_CustomerContactPersonActiveInActive,
                                                                  {
                                                                    CustomerContactPersonIDEncrypt:
                                                                      subitem.CustomerContactPersonIDEncrypt,
                                                                    CustomerProjectIDEncrypt:
                                                                      subitem.CustomerProjectIDEncrypt,
                                                                    IsActive:
                                                                      !subitem.IsActive,
                                                                    ModifiedByEncrypted:
                                                                      AuthUser?.ReferenceIDEncrypt
                                                                        ? AuthUser?.ReferenceIDEncrypt
                                                                        : "0",
                                                                  },
                                                                  setIsLoading,
                                                                  fnCallback,
                                                                  subitem.ContactPerson,
                                                                );
                                                              }}
                                                            >
                                                              <i
                                                                className={`fa fa-circle fs-15 ${
                                                                  subitem.IsActive ===
                                                                  true
                                                                    ? "text-success"
                                                                    : "text-danger"
                                                                }`}
                                                              ></i>
                                                            </Link>
                                                            {/* <Link
                                                                to="#"
                                                                className="icon-box icon-box-md bg-danger-light"
                                                                title="Delete"
                                                                onClick={() => {
                                                                  delete_Record(
                                                                    POST_CustomerContactPersonDelete,
                                                                    {
                                                                      CustomerContactPersonIDEncrypt:
                                                                        item.CustomerContactPersonIDEncrypt,
                                                                      CustomerProjectIDEncrypt:
                                                                        item.CustomerProjectIDEncrypt,
                                                                      ModifiedByEncrypted:
                                                                        AuthUser?.ReferenceIDEncrypt,
                                                                    },
                                                                    setIsLoading,
                                                                    fnCallback
                                                                  );
                                                                }}
                                                              >
                                                                {
                                                                  SVGICON.DeleteDanger
                                                                }
                                                              </Link> */}
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Contact Person
                                                            </h6>
                                                            <span>
                                                              {
                                                                subitem.ContactPerson
                                                              }
                                                            </span>
                                                          </Col>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Mobile No
                                                            </h6>
                                                            <span>
                                                              {subitem.MobileNo
                                                                ? subitem.MobileNo
                                                                : "-"}
                                                            </span>
                                                          </Col>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Telephone No
                                                            </h6>
                                                            <span>
                                                              {subitem.TelephoneNo
                                                                ? subitem.TelephoneNo
                                                                : "-"}
                                                            </span>
                                                          </Col>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Email{" "}
                                                            </h6>
                                                            <span>
                                                              {subitem.EmailID
                                                                ? subitem.EmailID
                                                                : "-"}
                                                            </span>
                                                          </Col>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Billing
                                                            </h6>
                                                            <span>
                                                              {subitem.IsBilling
                                                                ? "Yes"
                                                                : "No"}
                                                            </span>
                                                          </Col>
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              {" "}
                                                              Reporting
                                                            </h6>
                                                            <span>
                                                              {subitem.IsReporting
                                                                ? "Yes"
                                                                : "No"}
                                                            </span>
                                                          </Col>
                                                          {AuthUser?.Permissions
                                                            ?.DispatchReport ==
                                                            1 && (
                                                            <Col
                                                              lg={4}
                                                              className="mb-2"
                                                            >
                                                              <h6 className="mb-0">
                                                                {" "}
                                                                Dispatch{" "}
                                                              </h6>
                                                              <span>
                                                                {subitem.IsDispatch
                                                                  ? "Yes"
                                                                  : "No"}
                                                              </span>
                                                            </Col>
                                                          )}
                                                          {AuthUser?.Permissions
                                                            ?.DispatchMaterial ==
                                                            1 && (
                                                            <Col
                                                              lg={4}
                                                              className="mb-2"
                                                            >
                                                              <h6 className="mb-0">
                                                                Dispatch
                                                                Material
                                                              </h6>
                                                              <span>
                                                                {" "}
                                                                {subitem.IsDispatchMaterial
                                                                  ? "Yes"
                                                                  : "No"}
                                                              </span>
                                                            </Col>
                                                          )}
                                                          <Col
                                                            lg={4}
                                                            className="mb-2"
                                                          >
                                                            <h6 className="mb-0">
                                                              Designation{" "}
                                                            </h6>
                                                            <span className="ms-1">
                                                              {subitem.DesignationName
                                                                ? subitem.DesignationName
                                                                : "-"}
                                                            </span>
                                                          </Col>
                                                        </Row>
                                                      </div>
                                                      <hr className="mt-0"></hr>
                                                    </div>
                                                  </Accordion.Collapse>
                                                </Accordion.Item>
                                              ),
                                            )
                                          : ""}
                                      </Accordion>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                    </Row>
                    <hr className="mt-1 mb-2"></hr>
                    <button
                      type="submit"
                      // className="btn me-2 btn-primary"
                      className="btn btn-primary btn-sm me-2"
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </button>
                    <button
                      type="button"
                      // className="btn btn-danger light"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        if (IsQuickAddCustomerParam == "true") {
                          closeTab(2);
                        } else {
                          navigate(-1);
                        }
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </Form>
                </FormikProvider>
              </div>
            </Spin>
            <QuickAddCategory
              categoryType={categoryType}
              parentCategoryID={parentCategoryID}
              showModal={showQuickAddCategoryModal}
              setShowModal={setShowQuickAddCategoryModal}
              categoryTypeName={categoryTypeName}
              fnCallback={fnCallbackQuickAddCategory}
            />
            <Modal
              className="fade"
              show={addProjectDetailModal}
              onHide={setAddProjectDetailModal}
              size="lg"
            >
              <Spin
                size="large"
                spinning={isLoading}
                tip={"Loading..."}
                style={{ position: "fixed" }}
              >
                <FormikProvider value={formikCustomerProjectDetail}>
                  <Form onSubmit={formikCustomerProjectDetail.handleSubmit}>
                    <Modal.Header>
                      <Modal.Title>Project Details</Modal.Title>
                      <button
                        type="button"
                        variant=""
                        className="btn-close"
                        onClick={() => setAddProjectDetailModal(false)}
                      ></button>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        {" "}
                        <Col lg={4}>
                          <Link
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="Add"
                            style={{ float: "right" }}
                            //  onClick={addProjectName}
                            onClick={() => {
                              if (CustomerIDEncrypt) {
                                addProjectName(1);
                              } else {
                                warningMessage("Customer ID not Found...");
                              }
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                          <Field
                            label="Project Name"
                            name="CustomerProjectID"
                            placeholder={"Select Project Name"}
                            options={customerProjectListOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formikCustomerProjectDetail.setFieldValue(
                                "CustomerProjectID",
                                e?.value,
                              );
                              formikCustomerProjectDetail.setFieldValue(
                                "ProjectName",
                                e?.label,
                              );
                              formikCustomerProjectDetail.setFieldValue(
                                "ManagementName",
                                e?.ManagementName,
                              );
                              //setProjectName(e?.label);
                              setManagementName(e?.ManagementName);
                            }}
                            required
                          />
                          {managementName ? (
                            <>
                              <label>Management Name :</label> {managementName}{" "}
                              <Link
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                                onClick={editProjectName}
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col lg={4}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New Country"
                              style={{ float: "right" }}
                              onClick={() => {
                                setCategoryType(1);
                                setCategoryTypeName("Country");
                                setParentCategoryID(0);
                                setShowQuickAddCategoryModal(true);
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="Country"
                            name="CountryID"
                            placeholder={"Select Country"}
                            options={countryOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formikCustomerProjectDetail.setFieldValue(
                                "CountryID",
                                e?.value,
                              );
                              formikCustomerProjectDetail.setFieldValue(
                                "CountryName",
                                e?.label,
                              );
                              //setCountryName(e?.label);
                            }}
                            // required
                          />
                        </Col>
                        <Col lg={4}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New State"
                              style={{ float: "right" }}
                              onClick={() => {
                                if (CountryID) {
                                  setCategoryType(2);
                                  setCategoryTypeName("State");
                                  setParentCategoryID(CountryID);
                                  setShowQuickAddCategoryModal(true);
                                } else {
                                  // swal(
                                  //   "",
                                  //   "Please select Country first...",
                                  //   "warning"
                                  // );
                                  warningMessage(
                                    "Please select Country first...",
                                  );
                                }
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="State"
                            name="StateID"
                            placeholder={"Select State"}
                            options={stateOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formikCustomerProjectDetail.setFieldValue(
                                "StateID",
                                e?.value,
                              );
                              formikCustomerProjectDetail.setFieldValue(
                                "StateName",
                                e?.label,
                              );
                              //setStateName(e?.label);
                            }}
                            // required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label="Address Line 1"
                            name="Address"
                            // rows={4}
                            placeholder={"Enter Address Line 1"}
                            component={CustomTextArea}
                            maxLength={500}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            //type="text"
                            label={"Address Line 2"}
                            name="Address2"
                            placeholder={"Enter Address Line 2"}
                            component={CustomTextArea}
                            maxLength={500}
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            //type="text"
                            label={"Address Line 3"}
                            name="Address3"
                            placeholder={"Enter Address Line 3"}
                            component={CustomTextArea}
                            maxLength={500}
                          />
                        </Col>
                        <Col lg={4}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New City"
                              style={{ float: "right" }}
                              onClick={() => {
                                if (StateID) {
                                  setCategoryType(3);
                                  setCategoryTypeName("City");
                                  setParentCategoryID(StateID);
                                  setShowQuickAddCategoryModal(true);
                                } else {
                                  // swal(
                                  //   "",
                                  //   "Please select State first...",
                                  //   "warning"
                                  // );
                                  warningMessage(
                                    "Please select State first...",
                                  );
                                }
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="City"
                            name="CityID"
                            placeholder={"Select City"}
                            options={cityOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              if (e?.value != "") {
                                formikCustomerProjectDetail.setFieldValue(
                                  "CityID",
                                  e?.value,
                                );
                                formikCustomerProjectDetail.setFieldValue(
                                  "CityName",
                                  e?.label,
                                );
                              } else {
                                formikCustomerProjectDetail.setFieldValue(
                                  "CityID",
                                  "",
                                );
                                formikCustomerProjectDetail.setFieldValue(
                                  "CityName",
                                  "",
                                );
                              }
                              //setCityName(e?.label);
                            }}
                            // required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Pin Code"}
                            name="Pincode"
                            placeholder={"Enter Pin Code"}
                            component={CustomInput}
                            maxLength={20}
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Mobile No."}
                            name="MobileNo"
                            placeholder={"Enter Mobile No."}
                            countryCode={CountryCode}
                            component={CustomPhoneInput}
                            onChange={(value, { countryCode, dialCode }) => {
                              formikCustomerProjectDetail.setFieldValue(
                                "CountryCode",
                                dialCode,
                              );
                              formikCustomerProjectDetail.setFieldValue(
                                "MobileNo",
                                value.substring(dialCode.toString().length),
                              );
                            }}
                            onFocus={(value, { format }) => {
                              formikCustomerProjectDetail.setFieldValue(
                                "MobileNoFormat",
                                format,
                              );
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <label className="mb-1"> Billing</label>
                          <div className="mb-2 form-control form-control-sm">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsBilling"
                              checked={IsBilling}
                              onChange={(e) => {
                                formikCustomerProjectDetail.setFieldValue(
                                  "IsBilling",
                                  e.target.checked,
                                );
                              }}
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="IsBilling"
                            >
                              Billing
                            </label>
                          </div>
                        </Col>
                        <Col lg={4}>
                          <label className="mb-1"> Reporting</label>
                          <div className="mb-2 form-control form-control-sm">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsReporting"
                              checked={IsReporting}
                              onChange={(e) => {
                                formikCustomerProjectDetail.setFieldValue(
                                  "IsReporting",
                                  e.target.checked,
                                );
                              }}
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="IsReporting"
                            >
                              Reporting
                            </label>
                          </div>
                        </Col>
                        {AuthUser?.Permissions?.DispatchReport == 1 && (
                          <Col lg={4}>
                            <label className="mb-1"> Dispatch Report</label>
                            <div className="mb-2 form-control form-control-sm">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="IsDispatchReport"
                                checked={IsDispatchReport}
                                onChange={(e) => {
                                  formikCustomerProjectDetail.setFieldValue(
                                    "IsDispatchReport",
                                    e.target.checked,
                                  );
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="IsDispatchReport"
                              >
                                Dispatch Report
                              </label>
                            </div>
                          </Col>
                        )}
                        {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                          <Col lg={4}>
                            <label className="mb-1"> Dispatch Material</label>
                            <div className="mb-2 form-control form-control-sm">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="IsDispatchMaterial"
                                checked={IsDispatchMaterial}
                                onChange={(e) => {
                                  formikCustomerProjectDetail.setFieldValue(
                                    "IsDispatchMaterial",
                                    e.target.checked,
                                  );
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="IsDispatchMaterial"
                              >
                                Dispatch Material
                              </label>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}
                        {/* </Row>
                      <Row> */}
                      </Row>

                      {showQuickAddCategoryModal == true && (
                        <div className="fade modal-backdrop show"></div>
                      )}

                      {addProjectNameModal == true && (
                        <div className="fade modal-backdrop show"></div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        // className="btn me-2 btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        type="submit"
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {CustomerProjectIDEncrypt ? "Update" : "Submit"}
                      </button>
                      <button
                        type="button"
                        // className="btn btn-danger light"
                        className="btn btn-danger btn-sm"
                        onClick={() => setAddProjectDetailModal(false)}
                      >
                        <i className="fa fa-cancel"></i> Cancel
                      </button>
                    </Modal.Footer>
                  </Form>
                </FormikProvider>
              </Spin>
            </Modal>

            <Modal
              className="fade"
              show={addContactPersonsDetailModal}
              onHide={setAddContactPersonsDetailModal}
              size="lg"
            >
              <Spin
                size="large"
                spinning={isLoading}
                tip={"Loading..."}
                style={{ position: "fixed" }}
              >
                <FormikProvider value={formikCustomerContactPersonsDetail}>
                  <Form
                    onSubmit={formikCustomerContactPersonsDetail.handleSubmit}
                  >
                    <Modal.Header>
                      <Modal.Title> Contact Person Details</Modal.Title>
                      <button
                        type="button"
                        variant=""
                        className="btn-close"
                        onClick={() => setAddContactPersonsDetailModal(false)}
                      ></button>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Col lg={12}>
                          <Link
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="Add"
                            style={{ float: "right" }}
                            //onClick={addProjectName}
                            onClick={() => {
                              if (CustomerIDEncrypt) {
                                addProjectName(2);
                              } else {
                                warningMessage("Customer ID not Found...");
                              }
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                          <Field
                            label="Project Name"
                            name="CPDCustomerProjectID"
                            placeholder={"Select Project Name"}
                            options={customerProjectListOptions}
                            component={CustomMultiSelect}
                            isMulti={true}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Contact Person"}
                            name="CPDContactPerson"
                            placeholder={"Enter Contact Person"}
                            component={CustomInput}
                            maxLength={100}
                            required
                            onChange={(e) => {
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "CPDContactPerson",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Mobile No."}
                            name="CPDMobileNo"
                            placeholder={"Enter Mobile No."}
                            countryCode={CPDCountryCode}
                            component={CustomPhoneInput}
                            onChange={(value, { countryCode, dialCode }) => {
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "CPDCountryCode",
                                dialCode,
                              );
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "CPDMobileNo",
                                value.substring(dialCode.toString().length),
                              );
                            }}
                            onFocus={(value, { format }) => {
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "MobileNoFormat",
                                format,
                              );
                            }}
                            // required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Telephone No."}
                            name="CPDTelephoneNo"
                            placeholder={"Enter Telephone No."}
                            component={CustomInput}
                            maxLength={50}
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="email"
                            label={"Email"}
                            name="CPDEmailID"
                            placeholder={"Enter Email"}
                            component={CustomInput}
                            maxLength={100}
                            // required
                            validate={validateEmailField}
                          />
                        </Col>
                        <Col lg={4}>
                          {AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                            ?.length > 0 ? (
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New Designation"
                              style={{ float: "right" }}
                              onClick={() => {
                                setCategoryType(5);
                                setCategoryTypeName("Designation");
                                setParentCategoryID(0);
                                setShowQuickAddCategoryModal(true);
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                          ) : (
                            ""
                          )}
                          <Field
                            label="Designation"
                            name="CPDDesignation"
                            placeholder={"Select Designation"}
                            options={designationOptions}
                            component={CustomSelect}
                            onChange={(e) => {
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "CPDDesignation",
                                e?.value,
                              );
                              formikCustomerContactPersonsDetail.setFieldValue(
                                "DesignationName",
                                e?.label,
                              );
                              //setDesignationName(e?.label);
                            }}
                            // required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="text"
                            label={"Stamp WriteUp"}
                            name="CPDStempWriteup"
                            placeholder={"Enter Stamp WriteUp"}
                            component={CustomInput}
                            maxLength={500}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={8}>
                          <Row>
                            <Col lg={6}>
                              <label className="mb-1"> Billing</label>
                              <div className="mb-2 form-control form-control-sm">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="CPDIsBilling"
                                  checked={CPDIsBilling}
                                  onChange={(e) => {
                                    formikCustomerContactPersonsDetail.setFieldValue(
                                      "CPDIsBilling",
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor="CPDIsBilling"
                                >
                                  Billing
                                </label>
                              </div>
                            </Col>
                            <Col lg={6}>
                              <label className="mb-1"> Reporting</label>
                              <div className="mb-2 form-control form-control-sm">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="CPDIsReporting"
                                  checked={CPDIsReporting}
                                  onChange={(e) => {
                                    formikCustomerContactPersonsDetail.setFieldValue(
                                      "CPDIsReporting",
                                      e.target.checked,
                                    );
                                  }}
                                />
                                <label
                                  className="form-check-label ms-2"
                                  htmlFor="CPDIsReporting"
                                >
                                  Reporting
                                </label>
                              </div>
                            </Col>
                            {AuthUser?.Permissions?.DispatchReport == 1 && (
                              <Col lg={6}>
                                <label className="mb-1"> Dispatch</label>
                                <div className="mb-2 form-control form-control-sm">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="CPDIsDispatch"
                                    checked={CPDIsDispatch}
                                    onChange={(e) => {
                                      formikCustomerContactPersonsDetail.setFieldValue(
                                        "CPDIsDispatch",
                                        e.target.checked,
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="CPDIsDispatch"
                                  >
                                    Dispatch
                                  </label>
                                </div>
                              </Col>
                            )}
                            {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                              <Col lg={6}>
                                <label className="mb-1">
                                  {" "}
                                  Dispatch Material
                                </label>
                                <div className="mb-2 form-control form-control-sm">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="CPDIsDispatchMaterial"
                                    checked={CPDIsDispatchMaterial}
                                    onChange={(e) => {
                                      formikCustomerContactPersonsDetail.setFieldValue(
                                        "CPDIsDispatchMaterial",
                                        e.target.checked,
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="CPDIsDispatchMaterial"
                                  >
                                    Dispatch Material
                                  </label>
                                </div>
                              </Col>
                            ) : (
                              ""
                            )}
                          </Row>
                        </Col>
                        <Col lg={4}>
                          <label className="mb-1">Stamp</label>
                          {/* <div className="image-placeholder square-placeholder">  */}
                          <div className="image-placeholder companyLogo-placeholder">
                            <div className="avatar-edit">
                              <input
                                type="file"
                                id="imageUpload"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={uploadStampImage}
                              />
                              <label htmlFor="imageUpload" name=""></label>
                            </div>
                            <div
                              id="removeFile"
                              className="avatar-delete"
                              onClick={() => {
                                setStampImageFile(null);
                                setStampImage(null);
                                formikCustomerContactPersonsDetail.setFieldValue(
                                  "CPDStempImageURL",
                                  "",
                                );
                              }}
                            >
                              <label htmlFor="removeFile" name=""></label>
                            </div>
                            <div className="avatar-preview">
                              <div id="imagePreview">
                                <img
                                  id="saveImageFile"
                                  src={stampImage ? stampImage : img200}
                                  alt={"Stamp Image"}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="invalid-feedback animated fadeInUp d-block">
                            {validationStampImage}
                          </div>
                        </Col>
                      </Row>
                      {CustomerContactPersonIDEncrypt ? (
                        <Row>
                          <Col lg={4}>
                            <label className="mb-1">
                              Person Active/InActive
                            </label>
                            <div className="mb-2 form-control form-control-sm">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="CPDIsActive"
                                checked={CPDIsActive}
                                onChange={(e) => {
                                  formikCustomerContactPersonsDetail.setFieldValue(
                                    "CPDIsActive",
                                    e.target.checked,
                                  );
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="CPDIsActive"
                              >
                                Active/InActive
                              </label>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      {showQuickAddCategoryModal == true && (
                        <div className="fade modal-backdrop show"></div>
                      )}

                      {addProjectNameModal == true && (
                        <div className="fade modal-backdrop show"></div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        // className="btn me-2 btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        type="submit"
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {CustomerProjectIDEncrypt ? "Update" : "Submit"}
                      </button>
                      <button
                        type="button"
                        // className="btn btn-danger light"
                        className="btn btn-danger btn-sm"
                        onClick={() => setAddContactPersonsDetailModal(false)}
                      >
                        <i className="fa fa-cancel"></i> Cancel
                      </button>
                    </Modal.Footer>
                  </Form>
                </FormikProvider>
              </Spin>
            </Modal>

            <Modal
              className="fade"
              show={addProjectNameModal}
              onHide={setAddProjectNameModal}
            >
              <Spin
                size="large"
                spinning={isLoading}
                tip={"Loading..."}
                style={{ position: "fixed" }}
              >
                <FormikProvider value={formikCustomerProjectNameAdd}>
                  <Form onSubmit={formikCustomerProjectNameAdd.handleSubmit}>
                    <Modal.Header>
                      <Modal.Title>
                        {CustomerProjectIDEncrypt
                          ? "Edit Project"
                          : "Add Project"}
                      </Modal.Title>
                      <Button
                        type="button"
                        variant=""
                        className="btn-close"
                        onClick={() => setAddProjectNameModal(false)}
                      ></Button>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Col lg={12}>
                          <Field
                            label="Project Name"
                            name="ProjectName"
                            placeholder={"Enter Project Name"}
                            component={CustomInput}
                            maxLength={500}
                            required
                            onChange={(e) => {
                              formikCustomerProjectNameAdd.setFieldValue(
                                "ProjectName",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                          />
                        </Col>
                        <Col lg={12}>
                          <Field
                            label="Management Name"
                            name="ManagementName"
                            placeholder={"Enter Management Name"}
                            component={CustomInput}
                            maxLength={500}
                            onChange={(e) => {
                              formikCustomerProjectNameAdd.setFieldValue(
                                "ManagementName",
                                capitalizeString(e?.target?.value),
                              );
                            }}
                            // required
                          />
                        </Col>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        // className="btn me-2 btn-primary"
                        className="btn btn-primary btn-sm me-2"
                        type="submit"
                      >
                        <i className="fa-solid fa-floppy-disk"></i>{" "}
                        {CustomerProjectIDEncrypt ? "Update" : "Add"}
                      </button>
                      <button
                        type="button"
                        // className="btn btn-danger light"
                        className="btn btn-danger btn-sm"
                        onClick={() => setAddProjectNameModal(false)}
                      >
                        <i className="fa fa-cancel"></i> Cancel
                      </button>
                    </Modal.Footer>
                  </Form>
                </FormikProvider>
              </Spin>
            </Modal>
          </div>
        </div>
      </Fragment>
    </>
  );
};

export default AddCustomer;
